<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    
    <v-toolbar flat color="white">
      <!-- <v-btn color="primary" dark class="mb-2" @click="newDialog=true" round>ADD APPLICANT</v-btn> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="showNewApplications=true;showResolvedApplications=false">
          Pending Applications <v-chip color="primary" class="white--text">{{newApplications.length}}</v-chip>
        </v-tab>
        <v-tab @click="showNewApplications=false;showResolvedApplications=true">
          Resolved Applications  <v-chip color="blue" class="white--text">{{resolvedApplications.length}}</v-chip>
        </v-tab>
        <!-- <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab> -->
      </v-tabs>
    </v-toolbar>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-data-table
    v-if="showNewApplications"
      :headers="newHeaders"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :rows-per-page-items="[25, 50, 100, 250]"
      :loading="loading"
      :items="newApplications"
      :search="search"
      item-key="id"
      disable-initial-sort
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
             
               <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.createdAt)}}</td>
               <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.name}}</td>
              <td @click="routerLinkToDetails(props.item)"><h3 class="grey--text font-weight-light">{{props.item.vatNo}}</h3></td>
             <td @click="routerLinkToDetails(props.item)"><h3 class="grey--text font-weight-light">{{props.item.websiteUrl}}</h3></td>
             <td @click="routerLinkToDetails(props.item)"><h3 class="grey--text font-weight-light">{{props.item.fupUrl}}</h3></td>
             <td @click="routerLinkToDetails(props.item)"><h3 class="grey--text font-weight-light">{{props.item.termsAndConditionsLink}}</h3></td>
             <td @click="routerLinkToDetails(props.item)"><h3 class="grey--text font-weight-light">{{props.item.preferredVlan}}</h3></td>

             <td @click="routerLinkToDetails(props.item)" v-if="props.item.logo!=null">  <v-icon color="green">done</v-icon></td>
             <td @click="routerLinkToDetails(props.item)" v-else><v-icon color="red">not_interested</v-icon></td>   
             <td @click="routerLinkToDetails(props.item)" v-if="props.item.icasaDocument!=null"> <v-icon color="green">done</v-icon></td>
             <td @click="routerLinkToDetails(props.item)" v-else><v-icon color="red">not_interested</v-icon></td>     
       
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isValidated">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>

        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isDocumentsVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>

         <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isLinksVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>

        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isContactVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>
        <td class="text-xs-center" v-if="props.item.primaryContactTitle!==null" @click="routerLinkToDetails(props.item)">{{props.item.primaryContactTitle + ' '+props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">{{props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    <v-flex  v-if="showResolvedApplications">
      <v-data-table
      :headers="resolvedHeaders"
      class="elevation-1"
      :rows-per-page-items="[25, 50, 100, 250]"
      :loading="loading"
      :pagination.sync="resolvedPagination"
      :items="resolvedApplications"
      :search="search"
      item-key="id"
      disable-initial-sort
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.createdAt)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isApproved">
        <v-chip small class="green white--text">Approved</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-chip small class="red white--text">Denied</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.name}}</td>
             <td v-if="props.item.primaryContactId!==null" class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.primaryContactTitle + ' '+props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}
        </td>
        
        <td class="text-xs-center" v-else></td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{formatDate(props.item.resolvedDate)}}</td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.resolvedBy}}</td>
        
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.deniedReason}}
        </td>
        
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    </v-flex>
     
  </div>
</template>
<script>
import Api from '@/services/Api.js'
import dateformat from "dateformat";

export default {
    data(){
        return {
             expand: false,
            loading: false,
            resolvedPagination: {
              descending: true,
              activeTabName: '',
              sortBy: "resolvedDate"
        },
      pagination: {
          descending: true,
          activeTabName: '',
          sortBy: "createdAt"
        },
       tabs: [
        { name: "newApplications", displayName: "Pending" },
        { name: "resolvedApplications", displayName: "Resolved" }
      ],
      resolvedHeaders: [
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Status",
          align: "center"
        },
        {
          text: "Organisation Name",
          align: "center",
          value: "name"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "resolvedDate"
        },
        {
          text: "Resolved By",
          align: "center",
          value: 'resolvedBy'
        },
        {
          text: "Comment",
          align: "center",
          value: 'deniedReason'
        },
      ],
      newHeaders: [
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Organisation Name",
          align: "center",
          value: "name"
        },
        {
          text: "VAT No",
          align: "center",
          value: "vatNo"
        },
        {
          text: "Website URL",
          align: "center",
          value: "websiteUrl"
        },
        {
          text: "FUP URL",
          align: "center",
          value: "fupUrl"
        },
        {
          text: "T's & C's Link",
          align: "center",
          value: "termsAndConditionsLink"
        },
        {
          text: "Preferred VLAN",
          align: "center",
          value: "preferedVlan"
        },
        {
          text: "Logo",
          align: "center"
        },
        {
          text: "ICASA Document",
          align: "center"
        },
        {
          text: "Required Fields Validated",
          align: "center"
        },
        {
          text: "Documents Verified",
          align: "center"
        },
        {
          text: "Links Verified",
          align: "center"
        },
        {
          text: "Contact Verified",
          align: "center"
        },
        {
          text: "Primary Contact",
          align: "center"
        }
      ],
          snackbar: false,
          text: "",
          y: "top",
          showNewApplications:true,
          showResolvedApplications:false,
          newApplications:[],
          resolvedApplications:[],
           organisationApplications:[],
            pagination1: {
              sortBy: 'createdAt', 
             descending: true
        },
            orgId:null,
            search:'',
            currentPage: 1,
            key: 0,
        }
    },
    created(){
        this.fetchOrganisationApplications() 
    },
    methods: {
        fetchOrganisationApplications(){
            this.isLoading=true
             Api()
            .get('/organisationApplications')
            .then( response=>{  
             this.organisationApplications=response.data
             this.isLoading=false
              this.newApplications=this.organisationApplications.filter(function(el){
            return el.isResolved===false
                      })
          this.resolvedApplications=this.organisationApplications.filter(function(el){
            return el.isResolved===true
          })
          for(let k=0; k<this.resolvedApplications.length; k++){
            Api().get('/contacts/' + this.resolvedApplications[k].resolvedById).then(response=>{
              this.resolvedApplications[k].resolvedBy = response.data[0].name + ' ' + response.data[0].surname 
            })
          }
        })
        },
      async routerLinkToDetails(item) { 
      let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/organisationApplications/:organisationApplicationId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/organisationApplications/" + this.editedItem.id });
    },     
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
   }
    
}
</script>